// Modernized Calculator JS

// Calc1A: Oval/Rectangular Pond Surface Area
const Calc1A = () => {
  const form = document.forms["calc1A"];
  const length = parseFloat(form.elements["length1A"].value);
  const width = parseFloat(form.elements["width1A"].value);
  const surface = Math.ceil(length * width);
  form.elements["resultSurface1A"].value = surface;
};

// Calc1B: Round Pond Surface Area
const Calc1B = () => {
  const form = document.forms["calc1B"];
  const diameter = parseFloat(form.elements["diameter1B"].value);
  const surface = Math.ceil(diameter * diameter * 0.78);
  form.elements["resultSurface1B"].value = surface;
};

// Calc2A: Oval/Rectangular Pond Water Volume
const Calc2A = () => {
  const form = document.forms["calc2A"];
  const length = parseFloat(form.elements["length2A"].value);
  const width = parseFloat(form.elements["width2A"].value);
  const depth = parseFloat(form.elements["depth2A"].value);
  const volume = Math.ceil(length * width * depth * 7.48);
  form.elements["resultVolume2A"].value = volume;
};

// Calc2B: Round Pond Water Volume
const Calc2B = () => {
  const form = document.forms["calc2B"];
  const diameter = parseFloat(form.elements["diameter2B"].value);
  const depth = parseFloat(form.elements["depth2B"].value);
  const volume = Math.PI * Math.pow(diameter / 2, 2) * depth * 7.48;
  form.elements["resultVolume2B"].value = volume.toFixed(2);
};

// Calc3A: Pond Liner Size
const Calc3A = () => {
  const form = document.forms["calc3A"];
  const length = parseFloat(form.elements["length3A"].value);
  const width = parseFloat(form.elements["width3A"].value);
  const depth = parseFloat(form.elements["depth3A"].value);
  const linerLength = Math.ceil(length + depth * 2 + 1);
  const linerWidth = Math.ceil(width + depth * 2 + 1);
  form.elements["resultLinerLength"].value = linerLength;
  form.elements["resultLinerWidth"].value = linerWidth;
};

// Calc3B: Underlayment Calculator
const Calc3B = () => {
  const form = document.forms["calc3B"];
  const length = parseFloat(form.elements["underLength"].value);
  const width = parseFloat(form.elements["underWidth"].value);
  const depth = parseFloat(form.elements["underDepth"].value);
  if (isNaN(length) || isNaN(width) || isNaN(depth)) {
    document.getElementById("lengthError").textContent =
      "Please enter valid numeric values for all dimensions.";
    return;
  }
  const underlaymentLength = Math.ceil(2 * depth + length + 1);
  const rawUnderlaymentWidth = Math.ceil(2 * depth + width + 1);
  const multiplication = underlaymentLength * rawUnderlaymentWidth;
  const roundedUnderlaymentWidth = [10, 12, 15].reduce((prev, curr) =>
    Math.abs(curr - rawUnderlaymentWidth) <
    Math.abs(prev - rawUnderlaymentWidth)
      ? curr
      : prev
  );
  const finalUnderLaymentLength = Math.ceil(
    multiplication / roundedUnderlaymentWidth
  );
  form.elements["resultUnderLength"].value = finalUnderLaymentLength;
  form.elements["resultUnderWidth"].value = roundedUnderlaymentWidth;
  document.getElementById("lengthError").textContent = "";
  document.getElementById("widthError").textContent = "";
  document.getElementById("depthError").textContent = "";
};

// CalcD: Pump Head Pressure
const CalcD = () => {
  const form = document.forms["calcD"];
  const rise = parseFloat(form.elements["rise"].value);
  const hose = parseFloat(form.elements["hose"].value);
  const pressure = parseFloat(form.elements["pressure"].value);
  const fittings = parseFloat(form.elements["fittings"].value);
  const head = Math.ceil(rise + hose / 10 + pressure / 2 + fittings / 4);
  document.forms["outputD"].elements["resultD"].value = head;
};

// CalcF: Pump Cost/Usage
const CalcF = () => {
  const form = document.forms["calcF"];
  const watt = parseFloat(form.elements["pumpRating"].value);
  const costPerKw = parseFloat(form.elements["kwhrF"].value);
  const cost = ((watt * 24) / 1000) * costPerKw;
  const finalCost = Math.round(cost * 100) / 100;
  document.forms["outputF"].elements["resultF"].value = finalCost;
};

// CalcE: Pump Flow Rate
const CalcE = () => {
  const form = document.forms["calcE"];
  const width = parseFloat(form.elements["spillwayWidth"].value);
  const depth = parseFloat(form.elements["spillwayDepth"].value);
  const flow = Math.ceil(depth * width * (3.1 + (depth - 1)) * 60);
  document.forms["outputE"].elements["resultE"].value = flow;
};
